// ----------------------------------------------------------------------
// <copyright file="Izenda.InstanceName.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function () {
  "use strict";

  var React = require('react');
  var observer = require('mobx-react').observer;
  var Validator = require('share/components/hoc/Izenda.Validator');
  var Input = require('share/components/controls/Izenda.Input');
  var ValidatableInput = Validator()(Input);
  var ReportSubscriptionConstants = require('logic/data/Izenda.ReportSubscriptionConstants');
  var localizer = require('share/localization/Izenda.Localizer');

  var InstanceName = function (props) {
    /**
     * Get instance name
     */
    function getInstanceName() {
      return props.data ? props.data.name : '';
    };

    /**
     * onchange instance name
     * @param {object} input
     */
    function onChangeInstanceName(input) {
      props.data.updateProperty('name', input.target.value);
    };

    return (
      <div className='form-group Izenda-Subscription-InstanceName'>
        <div className='col-md-3 control-label'>{localizer.getText('SUBSCRIPTION_LABEL_INSTANCE_NAME')}</div>
        <div className='col-md-9'>
          <ValidatableInput className='form-control'
                            onChange={onChangeInstanceName}
                            value={getInstanceName()}
                            validations={ReportSubscriptionConstants.CONTRAINTS.INSTANCE_NAME}
                            field='name' />
        </div>
      </div>
    );
  };

  InstanceName.propTypes = {
    data: React.PropTypes.object
  };

  module.exports = observer(InstanceName);
}());


// WEBPACK FOOTER //
// ./ui/modules/Subscription/Izenda.InstanceName.jsx